<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import Input from '@components/Input.svelte';
  import Button from '@components/Button.svelte';
  import Notification from '@utils/notification';
  import InternalAdmin from '@ajax/internal_admin';

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let mobile = false;
  export let user = {};

  let imageUrl = '';
  let description = 'Thank you!';
  let amount = '';
  let showConfirmation = false;
  let loading = false;

  const close = () => {
    showModal = false;
    imageUrl = '';
    description = '';
    amount = '';
    showConfirmation = false;
    loading = false;
    dispatch('close');
  };

  const showConfirmationDialog = () => {
    // Validate inputs
    if (!description) {
      return Notification.send({
        text: 'Please add a description for the bonus transaction',
        type: 'error',
      });
    }

    if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
      return Notification.send({
        text: 'Please enter a valid amount',
        type: 'error',
      });
    }

    showConfirmation = true;
  };

  const createBonusTransaction = async () => {
    loading = true;
    try {
      const data = {
        user_id: user.id,
        image_url: imageUrl,
        description: description,
        amount: parseFloat(amount),
      };

      await InternalAdmin.createBonusTransaction(data);

      Notification.send({
        text: `Successfully created bonus transaction of $${amount}`,
      });

      close();
    } catch (err) {
      if (err && err.error) {
        Notification.send({
          text: err.error,
          type: 'error',
        });
      } else {
        Notification.send({
          text: 'Failed to create bonus transaction',
          type: 'error',
        });
      }
    } finally {
      loading = false;
    }
  };
</script>

<style lang="scss">
  .confirmation-message {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    margin: 20px 0;
  }

  .amount {
    font-weight: bold;
    color: #7054dc;
  }

  .button-container {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
</style>

<Modal
  mobile={mobile}
  on:close={close}
  show={showModal}
  showCloseButton={true}
  fadeInDuration={200}
  containerClass={mobile ? 'mobile-modal__container' : ''}>
  <div slot="header">
    {#if showConfirmation}
      Confirm Bonus Transaction
    {:else}
      New Bonus Transaction
    {/if}
  </div>
  <div slot="content">
    {#if showConfirmation}
      <div class="confirmation-message">
        Are you sure you want to create a bonus transaction of <span class="amount">${amount}</span> for {user.name}?
      </div>
      <div class="button-container" style="display: flex; justify-content: space-between; gap: 25px;">
        <Button text="Cancel" colorScheme="red" on:click={() => (showConfirmation = false)} />
        <Button loading={loading} text="Confirm" colorScheme="purple" on:click={createBonusTransaction} />
      </div>
    {:else}
      <div style="margin-bottom: 16px">
        <Input label="Image URL" bind:value={imageUrl} placeholder="https://example.com/image.png (optional)" />
      </div>
      <div style="margin-bottom: 16px">
        <Input value={user.id} type="hidden" />
      </div>
      <div style="margin-bottom: 16px">
        <Input label="Description" bind:value={description} placeholder="Enter transaction description" />
      </div>
      <div style="margin-bottom: 26px">
        <Input label="Amount($)" bind:value={amount} placeholder="0.00" />
      </div>
      <Button text="Save" colorScheme="purple" on:click={showConfirmationDialog} />
    {/if}
  </div>
</Modal>
